import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import VueAxios from 'vue-axios';

import Home from '../views/Home.vue';
import EnvioDocs from '../views/EnvioDocs.vue';
import ListadoDocs from '../views/ListadoDocs.vue';
import EFirmaContratos from '../views/EFirmaContratos.vue';
import EFirmaSoloYo from '../views/EFirmaSoloYo.vue';
import EFirmaActaComiteTrabajadores from '../views/EFirmaActaComiteTrabajadores.vue';
import EFirmaConsejoAdministracion from '../views/EFirmaConsejoAdministracion.vue';
import NotFound from '../views/NotFound.vue';

Vue.use(VueRouter);
Vue.use(VueAxios, axios);
axios.defaults.baseURL = process.env.VUE_APP_HOSTPYAPI;
// process.env.NODE_ENV !== "production"
//   ? process.env.VUE_APP_API_MANUSA_DEV
//   : process.env.VUE_APP_API_MANUSA_PROD;

//moment - locale - es
const moment = require('moment');
require('moment/locale/es');
Vue.use(require('vue-moment'), {
  moment
});
console.log(Vue.moment().locale()); //es

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/gestion-documentos',
    name: 'EnvioDocs',
    component: EnvioDocs
  },
  {
    path: '/gestion-documentos-listado',
    name: 'ListadoDocs',
    component: ListadoDocs
  },
  {
    path: '/efirma-contratos',
    name: 'EFirmaContratos',
    component: EFirmaContratos
  },
  {
    path: '/efirma-soloyo',
    name: 'EFirmaSoloYo',
    component: EFirmaSoloYo
  },
  {
    path: '/efirma-acta-comite-trabajadores',
    name: 'EFirmaActaComiteTrabajadores',
    component: EFirmaActaComiteTrabajadores
  },
  {
    path: '/efirma-consejo-administracion',
    name: 'EFirmaConsejoAdministracion',
    component: EFirmaConsejoAdministracion
  },
  {
    path: '/efirma-firmanvarios',
    name: 'EFirmaFirmanVarios',
    component: () => import('../views/EFirmaFirmanVarios.vue')
  },
  { path: '*', component: NotFound }
];

const router = new VueRouter({
  routes,
  linkActiveClass: 'active',
  mode: 'history',
  base: process.env.BASE_URL
});

export default router;
